<template>
  <div class="userSelection common_group">
    <div class="title">
      <img src="@/assets/images/userIcon.png">
      <span>{{ $t('newApp.Catalogue.t') }}</span>
    </div>
    <el-form class="common_form" label-position="left" ref="activityCatalogue" :rules="rules" label-width="174px"
             :model="formData"
    >
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.Catalogue.zrs')" prop="zrs">
            <el-input v-model="formData.zrs" :disabled="isReadOnly"
                      @blur="(val) => { inviterNumFilter('zrs', formData.zrs); }" :maxlength="9"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.Catalogue.dws')" prop="dws">
            <el-input v-model="formData.dws" :disabled="isReadOnly || !isChange"
                      @blur="(val) => { inviterNumFilter('dws', formData.dws) }" :maxlength="9"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.Catalogue.create3m')" prop="create3m">
            <el-input v-model="formData.create3m" :disabled="isReadOnly" @change=""
                      @blur="(val) => { inviterNumFilter('create3m', formData.create3m); mvalue('create3m') }"
                      :maxlength="9"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.Catalogue.push3m')" prop="push3m">
            <el-input v-model="formData.push3m" :disabled="isReadOnly"
                      @blur="(val) => { inviterNumFilter('push3m', formData.push3m); mvalue('push3m') }"
                      :maxlength="9"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.Catalogue.create3mAmount')" prop="create3mAmount">
            <el-input v-model="formData.create3mAmount" :disabled="isAmountReadOnly"
                      @blur="(val) => { amountFilter('create3mAmount', formData.create3mAmount) }"
                      :maxlength="20"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.Catalogue.push3mAmount')" prop="push3mAmount">
            <el-input v-model="formData.push3mAmount" :disabled="isAmountReadOnly"
                      @blur="(val) => { amountFilter('push3mAmount', formData.push3mAmount) }"
                      :maxlength="20"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import requestBaseUrl from '@/API/request/baseUrl';
import { getTicket, isNotEmpty } from '@/utils/utils';

export default {
    name: 'UserSelection',
    data () {
        return {
            rules: {
                zrs: [
                    { required: true, message: `${this.$t('newApp.Catalogue.pzrs')}`, trigger: 'change' }
                ],
                dws: [
                    { required: true, message: `${this.$t('newApp.Catalogue.pdws')}`, trigger: 'change' }
                ]
                // create3m: [
                //     {
                //         validator: (rule, value, callback) => {
                //             if (!this.isChange && Number(value) < this.create3m) {
                //                 this.$set(this.formData, 'create3m', JSON.parse(JSON.stringify(this.create3m)))
                //             }
                //             callback();
                //         },
                //         trigger: 'change'
                //     }
                // ],
                // push3m: [
                //     {
                //         validator: (rule, value, callback) => {
                //             if (!this.isChange && Number(value) < this.push3m) {
                //                 this.$set(this.formData, 'push3m', JSON.parse(JSON.stringify(this.push3m)))
                //             }
                //             callback();
                //         },
                //         trigger: 'change'
                //     }
                // ],
            },
            formData: {
                zrs: '',
                dws: 0,
                create3m: 0,
                push3m: 0,
                create3mAmount: 0,
                push3mAmount: 0
            },
            baseUrl: `${requestBaseUrl}/customer/excel/1/`,
            uploadheaders: {
                sysId: window._env_.VUE_APP_SYSID,
                union_session_ticket: getTicket()
            },
            isReadOnly: false,
            isAmountReadOnly: false,
            isChange: false,
            create3m: 0,
            push3m: 0
        };
    },
    components: {
    },
    props: {
        editEchoData: {
            type: Object,
            default: () => {
                return {};
            }
        },
        cacheList: {
            type: Object,
            default: () => {
                return {};
            }
        },
        updateForm: {
            type: Function,
            default: () => {
                return {};
            }
        },
        setActivityForm: {
            type: Function,
            default: () => {
                return {};
            }
        }
    },
    watch: {
        cacheList: {
            handler (newVal, oldVal) {
                if (newVal.activityClassificationCode === 'AC_06') {
                    this.isChange = true;
                } else {
                    this.isChange = false;
                    if (this.cacheList.userList) {
                        // 从用户列表中提取所有用户ID并去重
                        // 1. 使用map提取所有用户id
                        // 2. 使用Set进行去重
                        // 3. 使用扩展运算符(...)将Set转换回数组
                        console.log(this.cacheList.userList);
                        const uniqueIds = [...new Set(this.cacheList.userList.map(item => item.clientName))];
                        // 将去重后的用户数量设置到表单数据中
                        // dws字段表示'单位数'
                        this.$set(this.formData, 'dws', uniqueIds.length);

                        // businessChanceList为业务机会，newBusOpp为是否可能产生新建业务机会
                        // create3m:相同id的,如果有一个newBusOpp为1的则计数1,相同id最多计1
                        // push3m:选择的业务数量之和,相同单位多条数据businessChanceList去重计数求和

                        // 初始化统计变量
                        let create3mCount = 0;
                        let push3mCount = 0;

                        // 创建一个Set用于存储已经处理过的id(用于create3m统计)
                        const processedIds = new Set();

                        // 创建一个Map用于存储每个单位对应的业务机会(用于push3m统计)
                        const unitOpportunities = new Map();

                        // 遍历用户列表进行统计
                        this.cacheList.userList.forEach(item => {
                            // 处理create3m统计
                            if (item.clientName && item.newBusOpp === 1 && !processedIds.has(item.clientName)) {
                                create3mCount++;
                                processedIds.add(item.clientName);
                            }
                            if (!item.clientName && item.newBusOpp === 1) {
                                create3mCount++;
                            }

                            // 根据id将业务机会添加到对应的单位Set中(自动去重)
                            if (item.clientName && item.businessChanceList && Array.isArray(item.businessChanceList)) {
                                // 如果单位不存在于Map中，则创建一个新的Set
                                if (!unitOpportunities.has(item.clientName)) {
                                    unitOpportunities.set(item.clientName, new Set());
                                }

                                // 将业务机会添加到对应的单位Set中(自动去重)
                                item.businessChanceList.forEach(opportunity => {
                                    if (opportunity) {
                                        unitOpportunities.get(item.clientName).add(opportunity);
                                    }
                                });
                            }
                        });

                        // 计算push3m统计结果：对每个单位的业务机会数量求和
                        unitOpportunities.forEach(opportunities => {
                            push3mCount += opportunities.size;
                        });

                        // // 更新表单数据
                        this.$set(this.formData, 'create3m', this.formData.create3m > create3mCount ? this.formData.create3m : create3mCount);
                        this.$set(this.formData, 'push3m', this.formData.push3m > push3mCount ? this.formData.push3m : push3mCount);
                        this.create3m = create3mCount;
                        this.push3m = push3mCount;
                    }
                    // this.$set(this.formData, 'dws', this.cacheList.userList ? this.cacheList.userList.length : 0)
                }
            },
            deep: true
        },
        formData: {
            handler (newVal, oldVal) {
                this.updateForm(newVal);
            },
            deep: true
        }
        // editEchoData: {
        //     immediate: true,
        //     deep: true,
        //     handler(newVal) {
        //         if (isNotEmpty(newVal) && isNotEmpty(newVal.marketActivity)) {
        //             this.$set(this.formData, 'zrs', newVal.marketActivity.inviterNum)
        //             this.$set(this.formData, 'dws', newVal.marketActivity.invitedUnitNum)
        //             this.$set(this.formData, 'create3m', newVal.marketActivity.newOpptyNum)
        //             this.$set(this.formData, 'push3m', newVal.marketActivity.pushOpptyNum)
        //         } else {
        //             this.$set(this.formData, 'zrs', "")
        //         }
        //     }
        // },

    },
    methods: {
        inviterNumFilter (prop, val) {
            val = String(val);
            // let numVal = val.replace(/[^\d]/g, '').replace(/^0{1,}/g, '');
            // 允许所有数字
            let numVal = val.replace(/[^\d]/g, '');
            this.$set(this.formData, prop, numVal);
            // 判断是否为拟邀请总人数，如果是则调用通用函数修改key的value
            if (prop === 'zrs') {
                this.setActivityForm('inviterNum', numVal);
            }
        },
        mvalue (props) {
            if (this.formData[props] < this[props]) {
                this.$set(this.formData, props, this[props]);
            }
            if (this.formData[props] === '') {
                this.$set(this.formData, props, 0);
            }
        },
        amountFilter (prop, val) {
            // 允许数字和小数点，最多两位小数
            let numVal = val.replace(/[^\d.]/g, '');
            // 确保只有一个小数点
            const parts = numVal.split('.');
            if (parts.length > 2) {
                numVal = parts[0] + '.' + parts.slice(1).join('');
            }
            // 最多两位小数
            if (parts.length === 2 && parts[1].length > 2) {
                numVal = parts[0] + '.' + parts[1].substring(0, 2);
            }
            this.$set(this.formData, prop, numVal);
        },
        validateHandler () {
            return new Promise((resolve, reject) => {
                this.$refs['activityCatalogue'].validate((valid) => {
                    if (valid) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                });
            });
        }
    },
    mounted () {
        if (this.$route.query.activityCode) {
            // 如果是转申请页或者报备编辑页就全部禁止操作
            // const pathList = ['/transferApplication', '/editReportApplication', '/activityTransferApplication', '/quickTransferApplication'];
             const pathList = ['/transferApplication', '/editReportApplication', '/quickTransferApplication'];
            if (pathList.includes(this.$route.path)) {
                this.isReadOnly = true;
            }
            // 金额字段仅在报备编辑页禁用，转申请时可编辑
            const amountReadOnlyList = ['/editReportApplication'];
            if (amountReadOnlyList.includes(this.$route.path)) {
                this.isAmountReadOnly = true;
            }
            this.$nextTick(() => {
                if (this.editEchoData && this.editEchoData.marketActivity) {
                    this.$set(this.formData, 'zrs', this.editEchoData.marketActivity.inviterNum || '');
                    this.$set(this.formData, 'dws', this.editEchoData.marketActivity.invitedUnitNum || 0);
                    this.$set(this.formData, 'create3m', this.editEchoData.marketActivity.newOpptyNum || 0);
                    this.$set(this.formData, 'push3m', this.editEchoData.marketActivity.pushOpptyNum || 0);
                    this.$set(this.formData, 'create3mAmount', this.editEchoData.marketActivity.newOpptyAmount || 0);
                    this.$set(this.formData, 'push3mAmount', this.editEchoData.marketActivity.pushOpptyAmount || 0);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped></style>
